import { Place, RawPlace } from './typings';

export const serializePlaceForFront = (data: RawPlace): Place => ({
  id: data.id,
  name: data.fields.Name,
});
